<div class="container">
    <h1>Agregar presentación</h1>

    <div class="card mt-3" style="background-color: #f5f5f5">
        <div class="card-body d-flex justify-content-between">
            <div class="description">
                <p class="card-text" style="color: black">
                    <span style="font-weight: bold">Nombre del producto:</span>
                    {{ product?.nombreComercial }}
                    <br />
                    <span style="font-weight: bold">
                        Casa productora / Planta productora:
                    </span>
                    {{ product?.casaProductora }}
                    <br />
                    <span style="font-weight: bold">
                        {{ 'presentaciones.numeroIca' | translate }}
                    </span>
                    {{ product?.numeroRegistroIca }}
                </p>
            </div>
        </div>
    </div>
    <form (ngSubmit)="onSubmitAgregarPresentation()" #presentationForm="ngForm">
        <div class="mb-2 mt-5">
            <div class="mb-3 row">
                <label for="dropdown1" class="col-sm-4 col-form-label">
                    Empaque
                    <sup class="text-danger">*</sup>
                </label>
                <div class="col-sm-8">
                    <select
                        class="form-select"
                        id="dropdown1"
                        [(ngModel)]="selectedEmpaque"
                        name="selectedEmpaque"
                        (change)="onChangeEmpaque()"
                        required>
                        <option value="" disabled selected class="grayed-text">
                            Selecciona empaque
                        </option>
                        <option
                            *ngFor="let option of optPackaging"
                            [value]="option.id">
                            {{ option.nombre }}
                        </option>
                    </select>
                </div>
                <div
                    *ngIf="
                        presentationForm.submitted &&
                        !presentationForm.controls['selectedEmpaque'].valid
                    "
                    class="text-danger">
                    ¡Empaque requerido!
                </div>
            </div>

            <div class="mb-3 row">
                <label for="dropdown2" class="col-sm-4 col-form-label">
                    Unidad de medida equivalente
                    <sup class="text-danger">*</sup>
                </label>
                <div class="col-sm-8">
                    <select
                        class="form-select"
                        id="dropdown2"
                        [(ngModel)]="selectedUnity"
                        name="selectedUnity"
                        required
                        (change)="onChange($event)">
                        <option value="" disabled selected class="grayed-text">
                            Selecciona medida
                        </option>
                        <option
                            *ngFor="let option of optUnitsOfMeasurement"
                            [value]="option.EmpaqueUnidadMedida.id"
                            [attr.data-codigo]="option.codigo">
                            {{ option.nombre }}
                        </option>
                    </select>
                </div>
                <div
                    *ngIf="
                        presentationForm.submitted &&
                        !presentationForm.controls['selectedUnity'].valid
                    "
                    class="text-danger">
                    ¡Unidad de medida requerida!
                </div>
            </div>

            <div class="mb-3 row">
                <label for="cantidad" class="col-sm-4 col-form-label">
                    Cantidad (valor contenido por empaque)
                    <sup class="text-danger">*</sup>
                </label>
                <div class="col-sm-8">
                    <input
                        type="number"
                        class="form-control"
                        id="cantidad"
                        name="quantity"
                        [(ngModel)]="quantity"
                        #qty="ngModel"
                        required
                        min="0"
                        max="99999"
                        maxlength="5"
                        step="1"
                        [disabled]="selectedTypeProduct === '4'"
                        (blur)="normalizeQuantity(1)" />
                </div>
                <div
                    *ngIf="
                        presentationForm.submitted &&
                        !presentationForm.controls['quantity'].valid
                    "
                    class="text-danger">
                    ¡Cantidad requerida!
                </div>
                <div *ngIf="qty.errors?.['max']" class="text-danger">
                    La cantidad debe ser menor a 100000.0
                </div>
            </div>

            <div class="mb-3 row align-items-center visibility">
                <label for="dropdown2" class="col-sm-6 col-form-label">
                    Unidad de presentación:
                </label>
                <div class="col-sm-6">
                    <div class="d-flex align-items-center">
                        <span>{{ selectedEmpaque }}</span>
                        <span>
                            {{ quantity ? padWithZeros(quantity) : quantity }}
                        </span>
                        <span>{{ codigoSeleccionado }}</span>
                    </div>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-success float-right">
            Guardar
        </button>
    </form>
</div>
